import Treatments from './constants';
import EnterpriseFeaturesGp69 from '~pricing/experiments/EnterpriseFeaturesGp69';
import Grow2427SocialProof from '~app/pages/Pricing/experiments/grow_2427_social_proof';
import Grow2529FormsTreatment1 from '~app/pages/Pricing/experiments/grow_2529_forms/treatment1';
import Grow2529FormsTreatment2 from '~app/pages/Pricing/experiments/grow_2529_forms/treatment2';
import Grow2629FormsV2Treatment from '~app/pages/Pricing/experiments/grow_2629_forms_packages/';

const activeTreatments = {
  [Treatments.ENTERPRISE_FEATURES_GP69]: {
    name: 'ENTERPRISE_FEATURES_GP69',
    component: EnterpriseFeaturesGp69,
  },
  [Treatments.GROW_2427_TREATMENT]: {
    name: 'GROW_2427_TREATMENT',
    component: Grow2427SocialProof,
  },
  [Treatments.GROW_2529_FORMS_TREATMENT1]: {
    name: 'GROW_2529_FORMS_TREATMENT1',
    component: Grow2529FormsTreatment1,
  },
  [Treatments.GROW_2529_FORMS_TREATMENT2]: {
    name: 'GROW_2529_FORMS_TREATMENT2',
    component: Grow2529FormsTreatment2,
  },
  [Treatments.GROW_2629_FORMS_V2_TREATMENT]: {
    name: 'GROW_2629_FORMS_V2_TREATMENT',
    component: Grow2629FormsV2Treatment,
  },
};

export default activeTreatments;
